import { Component } from '@theme/component';

class StickyAddToCartComponent extends Component {
  requiredRefs = ['stickyNavBar'];

  #anchorIntersectionObserver = null;

  #mainBottomObserver = null;

  #isStuck = false;

  #hiddenByBottom = false;

  #sectionElement = null;

  #detailsBody = null;

  #mobileQuery = window.matchMedia('(max-width: 749px)');

  connectedCallback() {
    super.connectedCallback();
    this.#setupIntersectionObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#anchorIntersectionObserver?.disconnect();
    this.#mainBottomObserver?.disconnect();
  }

  #getAnchor() {
    if (this.#mobileQuery.matches && this.#detailsBody) return this.#detailsBody;
    return this.#sectionElement;
  }

  #setupIntersectionObserver() {
    const sectionElement = this.closest('.shopify-section');
    if (!sectionElement) return;

    const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');
    if (!footer) return;

    this.#sectionElement = sectionElement;
    this.#detailsBody = sectionElement.querySelector('.product-details__body');

    this.#anchorIntersectionObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target !== this.#getAnchor()) continue;

        if (!entry.isIntersecting && !this.#isStuck) {
          const rect = entry.target.getBoundingClientRect();
          if (rect.bottom < 0) {
            this.#showStickyBar();
          }
        } else if (entry.isIntersecting && this.#isStuck) {
          this.#hiddenByBottom = false;
          this.#hideStickyBar();
        }
      }
    });

    this.#anchorIntersectionObserver.observe(sectionElement);
    if (this.#detailsBody) this.#anchorIntersectionObserver.observe(this.#detailsBody);

    this.#mainBottomObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (!entry) return;

        if (entry.isIntersecting && this.#isStuck) {
          this.#hiddenByBottom = true;
          this.#hideStickyBar();
        } else if (!entry.isIntersecting && this.#hiddenByBottom) {
          const rect = this.#getAnchor().getBoundingClientRect();
          if (rect.bottom < 0) {
            this.#hiddenByBottom = false;
            this.#showStickyBar();
          }
        }
      },
      {
        rootMargin: '200px 0px 0px 0px',
      }
    );

    this.#mainBottomObserver.observe(footer);
  }

  #showStickyBar() {
    this.#isStuck = true;
    this.refs.stickyNavBar.dataset.stuck = 'true';
  }

  #hideStickyBar() {
    this.#isStuck = false;
    this.refs.stickyNavBar.dataset.stuck = 'false';
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCartComponent);
}
